import { render, staticRenderFns } from "./EditGlobalAccount.vue?vue&type=template&id=71f1dc3e&scoped=true&"
import script from "./EditGlobalAccount.vue?vue&type=script&lang=js&"
export * from "./EditGlobalAccount.vue?vue&type=script&lang=js&"
import style0 from "./EditGlobalAccount.vue?vue&type=style&index=0&id=71f1dc3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1dc3e",
  null
  
)

export default component.exports